export const PRACTICE_LIST_GROUP = "Your manufacturers";
export const OTHER_RECORDS_GROUP = "Also on your records";

type GroupableManufacturer = { on_practice_list?: boolean };

/**
 * Report filters list the practice's own manufacturers and, under a second heading, the ones that
 * only appear on its records (taken off the list, or imported under another name), so every
 * existing hearing aid can still be filtered. A list with only one of the two needs no headings.
 */
export function getManufacturerGroupBy<T extends GroupableManufacturer>(
  options: readonly T[]
): ((option: T) => string) | undefined {
  const hasPracticeList = options.some((option) => option.on_practice_list);
  const hasOthers = options.some((option) => option.on_practice_list === false);
  if (!hasPracticeList || !hasOthers) return undefined;

  return (option) =>
    option.on_practice_list ? PRACTICE_LIST_GROUP : OTHER_RECORDS_GROUP;
}
